export default "__VITE_ASSET__BLzxbG$$__"